import type { BattlePhase, BattleRules, ElixirStage } from './types';

export function elixirStageAt(rules: BattleRules, phase: BattlePhase, phaseTick: number): ElixirStage {
  if (phase === 'overtime') return phaseTick >= rules.overtimeTripleElixirStartTick ? 'triple' : 'double';
  if (phase === 'normal' && phaseTick >= rules.normalDoubleElixirStartTick) return 'double';
  return 'single';
}

export function elixirRateAt(rules: BattleRules, phase: BattlePhase, phaseTick: number): number {
  const stage = elixirStageAt(rules, phase, phaseTick);
  if (stage === 'triple') return rules.tripleElixirPerTickMilli;
  if (stage === 'double') return rules.doubleElixirPerTickMilli;
  return rules.singleElixirPerTickMilli;
}

export function cardCooldownAt(rules: BattleRules, phase: BattlePhase, phaseTick: number): number {
  const stage = elixirStageAt(rules, phase, phaseTick);
  if (stage === 'triple') return rules.tripleCardCooldownTicks;
  if (stage === 'double') return rules.doubleCardCooldownTicks;
  return rules.singleCardCooldownTicks;
}
